export default __webpack_public_path__ + "static/media/ic_web_screening.6d67da98.png";